// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./themes/inspinia/js/plugins/jasny/jasny-bootstrap.min.css
// module id = 1302
// module chunks = 0